
const truncateMessage = function(message: string, maxLength: number = 20): string {
	const content = message

	if (content.length > maxLength) {
		return message.slice(0, maxLength) + '...';
	}
	return message;
}

export const ConfirmPane =function(props:{showConfirm:boolean,confirmClick:(confirmed: boolean) => void, confirmMessage:string}){
	if(props.showConfirm===false)return null;
	const displayMessage = truncateMessage(props.confirmMessage);
	return(
		<div id='teachers-confirmpane'>
			<div id='teachers-confirmpane-blocker'></div>
			<div id='teachers-confirmpane-pane'>
				<p>{displayMessage}</p>
				<button onClick={()=>{props.confirmClick(true)}} id='teachers-confirmpane-confirm'>Confirm</button>
				<button onClick={()=>{props.confirmClick(false)}} id='teachers-confirmpane-cancel'>Cancel</button>
			</div>
		</div>
	);
}

export const ConfirmPaneLockScroll=function(doLock:boolean){
	if(doLock){
		document.getElementsByTagName('body')[0].style.overflow = 'hidden';
	}else{
		document.getElementsByTagName('body')[0].style.overflow = 'visible';
	}
	
};